import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/shell/session'
import { Wrench } from 'lucide-react'
import { OperationsScreen } from '@/screens/platform/SCR-061-operations'

// SCR-061 Operations (platform area, super admins only).
export const Route = createFileRoute('/_app/platform/operations')({
  beforeLoad: requireSuperAdmin,
  staticData: { screen: { id: 'SCR-061', title: 'Operations', group: 'Platform', order: 2, platform: true, description: 'Service health, status checks, queues, workers, storage and backups on this data plane.', icon: Wrench } },
  component: OperationsScreen,
})
